export default class VideoEventHandler {

    constructor(player) {
        this.player = player

        this.initEventListener()
    }

    initEventListener() {
        this.player.on('play', (event) => {
            console.log(`"play" event - time: ${this.currentTime()} secs`)
        })
        this.player.on('pause', (event) => {
            console.log(`"pause" event - time: ${this.currentTime()} secs`)
        })
        this.player.on('timeupdate', (event) => {
            console.log(`"timeupdate" event - time: ${this.currentTime()} secs`)
        })
        this.player.on('seeking', (event) => {
            console.log(`"seeking" event - time: ${this.currentTime()} secs`)
        })
        this.player.on('seeked', (event) => {
            console.log(`"seeked" event - time: ${this.currentTime()} secs`)
        })
    }

    currentTime() {
        return this.player[0].currentTime
    }
}